var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Index_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: ".8em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M566.555 51.954a77.029 77.029 0 00-103.474 0L44.68 449.166a38.583 38.583 0 0051.68 57.325l6.651-6.331v414.583A77.166 77.166 0 00180.224 992h224.64V759.657a54.331 54.331 0 0154.377-54.4h105.691a54.354 54.354 0 0154.4 54.4V992h229.943a77.234 77.234 0 0077.234-77.257V505.21c17.143 15.52 41.463 14.332 55.749-1.554a38.583 38.583 0 00-2.789-54.514L566.555 51.977z",
    fill: "currentColor"
  })));
}
export default SvgIndex;